/* eslint-disable */
import uris from '../utils/uris'
import axios from '../utils/axiosWrapper'

// import _ from 'lodash'
import filter from 'lodash/filter'
import orderBy from 'lodash/orderBy'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'

let store = []
// let treeStore = []
let treeStore = []
let isLoaded = false

function setChildrenCount (arr) {
  const result = []
  arr.map((item, index) => {
    // eslint-disable-next-line
    item.children = filter(store, (i) => i.containedBy == item.itemID)
    item.childrenCount = item.children.length

    // item = {...item, get isPowerBI () { return this.imageUrl.indexOf('app.powerbi.com') > -1 }}
    // item = {...item, get isPowerBI () { return (this.imageUrl || '').indexOf('powerbi') > -1 }}
    item.isPowerBI = (item.url1 || '').indexOf('powerbi') > -1
    result.push(item)
  })
  return result
}

function counFavorite () {
  let _reports = filter(store, (item) => !item.isFolder && !item.hidden)
  return filter(_reports, (item) => item.isFavorite).length
}

export default {
  cleanStorage () {
    isLoaded = false
  },
  isDataLoaded () {
    return isLoaded
  },
  getTopReports () {
    let _reports = []
    let folderDownloadCube = this.findItemByName('download-cube')
    if (folderDownloadCube) {
      _reports = filter(store, (item) => !item.isFolder && !item.hidden && item.containedBy !== folderDownloadCube.itemID)
    } else {
      _reports = filter(store, (item) => !item.isFolder && !item.hidden)
    }
    let _reportsOrderByCreatedAt = orderBy(_reports, ['createdAt'], ['desc'])
    // console.log("Reports : ", _reports)
    // console.log("TopFrecuenteReports : ", orderBy(_reports, ['Views'], ['desc']).slice(0, 9))
    return {
      topFrecuenteReports: orderBy(filter(_reports, (item) => item.Views > 0), ['Views'], ['desc']).slice(0, 9),
      topFavoriteReports: filter(_reportsOrderByCreatedAt, (item) => item.isFavorite).slice(0, 3),
      topNovedadesReports: _reportsOrderByCreatedAt.slice(0, 5)
    }
  },
  getCountFavorite (options) {
    if (store.length == 0) {
      this.getData({
        forceLoad: true,
        onSuccess: () => {
          options.onSuccess(counFavorite())
        }
      })
    } else {
      options.onSuccess(counFavorite())
    }

  },
  getData (options) {
    /*
      options: {
        forceLoad true/false
        itemID: ''
        onSuccess()
        onError()
      }
    */
    // console.log('??????', 'DATA', {isLoaded, forceLoad: options.forceLoad})
    if (!isLoaded || options.forceLoad) {
      axios.get(uris.URL_GET_ITEMS)
        .then((response) => {
          // console.log('??????', 'NO DEBERIA', JSON.stringify(response.data.rows, null, 2), response.data.rows)
          isLoaded = true
          store = this.orderFolderBy(response.data.rows, ['isFolder', 'itemName'], ['desc', 'asc'])
          // EXPERIMENTAL: REMAP STORE
          // store = store.map(i => ({...i, isMoving: false}))
          if (options.onSuccess) {
            this.outputData(store, options)
          } else {
            console.warn('Store is loaded but no onSuccess detected')
          }
        }, (err) => {
          console.warn(err)
          if (options.onError) {
            options.onError(err)
          }
        })
    } else {
      if (options.onSuccess) {
        // console.log(store)
        store = store.slice()
        this.outputData(store, options)
      } else {
        console.warn('Store is cached but no onSuccess detected')
      }
    }
  },
  getAccessToken (idPbi, onSuccess) {
    // console.log("Id Power BI", idPbi)
    axios.post(uris.URL_POWERBI_ACCESS_TOKEN, {
      reportId : idPbi
    }).then((data) => {
      // console.log("DATA Power BI", data.data.rows)
      onSuccess(data.data.rows)
    })
  },
  outputData (store, options) {
    options.onSuccess(
      this.getChildrenByFolderID(store, options.folderID), store.map(i => i)
    )
  },
  getChildrenByFolderID (arr, folderID) {
    if (folderID) {
      return (
        setChildrenCount(
          // eslint-disable-next-line
          filter(arr, (item) => item.containedBy == folderID)
        )
      )
    }
    return arr
  },
  orderFolderBy (arr, fields, orders) {
    return orderBy(arr, fields, orders)
  },
  findItemByID (itemID) {
    // eslint-disable-next-line
    return find(store, (i) => i.itemID == itemID)
  },
  findItemByName (itemName) {
    // eslint-disable-next-line
    return find(store, (i) => i.itemName == itemName)
  },
  findItemsInFolder (folderID, type) {
    if (type === 'REPORTS') {
      // eslint-disable-next-line
      return filter(store, (i) => i.containedBy == folderID && !i.isFolder)
    } else if (type === 'FOLDERS') {
      // eslint-disable-next-line
      return filter(store, (i) => i.containedBy == folderID && i.isFolder)
    }
    // eslint-disable-next-line
    return filter(store, (i) => i.containedBy == folderID)
  },
  setFavorite (reportID, isFavorite, options) {
    const max = store.length
    for (let i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].reportID == reportID) {
        store[i].isFavorite = isFavorite
        return
      }
    }

    axios.post(uris.URL_SET_FAVORITE, {
      itemID: reportID
    })
      .then((response) => {
        // console.log('Agregado a favoritos', response)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('No se ha podido agregar a favoritos', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  buildTree (subs) {
    // eslint-disable-next-line
    const roots = filter(store, i => i.containedBy == '0')

    function getChildren (arr, parents) {
      for (let i = 0; i < parents.length; i++) {
        const r = parents[i]
        // eslint-disable-next-line
        r.checked = !isEmpty(find(subs, i => i.itemID == r.itemID))
        r.children = []
        if (r.isFolder) {
          r.children = []
          // eslint-disable-next-line
          const children = getChildren(arr, filter(arr, i => i.containedBy == r.itemID))
          r.children = children
          parents[i] = r
        }
      }
      return parents
    }
    treeStore = getChildren(store, roots)
    return treeStore
  },
  toggleTree (children, checked) {
    return children.map(item => {
      item.checked = checked
      item.children = this.toggleTree(item.children, checked)
      return item
    })
    /*
    for (let i = 0; i < children.length; i++) {
      children[i].checked = checked
      children[i].children = this.toggleTree(children[i].children, checked)
    }
    return children
    */
  },
  getDefaultPreviewImage () {
    return uris.URL_DEFAULT_PREVIEW_IMG
  },
  getDefaultPlaceholderImage () {
    return uris.URL_DEFAULT_PLACEHOLDER_IMG
  },
  registerView (reportID, viewType) {
    axios.post(uris.URL_REGISTER_VIEW, {
      itemID: reportID,
      viewType: viewType
    })
      .then((response) => {
        // console.log('Visita registrada', response)
      }, (err) => {
        console.warn('No pudo registrarse la visita', err)
      })
  },
  editItem (item, newItemData, options) {
    axios.post(uris.URL_EDIT_ITEM, {
      itemID: item.itemID,
      ...newItemData
    })
      .then((response) => {
        if (options && options.onSuccess) {
          options.onSuccess(response)
        }
        // console.log('EDITADO', response)
      }, (err) => {
        if (options && options.onError) {
          options.onError(err)
        }
        console.warn('No pudo EDITARSE', err)
      })
    const max = store.length
    for (let i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].itemID == item.itemID) {
        let s = store[i]
        if (s.isFolder) {
          s.itemName = newItemData.itemName
        } else {
          s.itemName = newItemData.itemName
          s.url1 = newItemData.url1
          s.url2 = newItemData.url2
          s.url3 = newItemData.url3
          s.url4 = newItemData.url4
          s.url5 = newItemData.url5
          s.imageUrl = newItemData.imageUrl
          s.description = newItemData.description
          s.labels = newItemData.labels
        }
        store[i] = s
        return true
      }
    }
  },
  moveItem (itemID, newContainedBy) {
    axios.post(uris.URL_MOVE_ITEM, {
      itemID,
      newContainedBy
    })
      .then((response) => {
        // console.log('MOVED', response)
      }, (err) => {
        console.warn('ERROR MOVING', err)
      })
    const max = store.length
    for (let i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].itemID == itemID) {
        store[i].containedBy = newContainedBy
        return true
      }
    }
  },
  hideItem (itemID) {
    axios.post(uris.URL_HIDE_ITEM, {
      itemID
    })
      .then((response) => {
        // console.log('HIDDEN', response)
      }, (err) => {
        console.warn('ERROR HIDDING', err)
      })
    const max = store.length
    for (let i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].itemID == itemID) {
        store[i].hidden = true
        return true
      }
    }
  },
  unHideItem (itemID) {
    axios.post(uris.URL_UNHIDE_ITEM, {
      itemID
    })
      .then((response) => {
        // console.log('UNHIDDEN', response)
      }, (err) => {
        console.warn('ERROR UNHIDDING', err)
      })
    const max = store.length
    for (let i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].itemID == itemID) {
        store[i].hidden = false
        return true
      }
    }
  },
  removeItem (itemID, options) {
    axios.post(uris.URL_REMOVE_ITEM, {
      itemID
    })
      .then((response) => {
        const max = store.length
        let removedItem = {}
        for (let i = 0; i < max; i++) {
          // eslint-disable-next-line
          if (store[i].itemID == itemID) {
            // console.log('found ', store[i])
            removedItem = store.splice(i, 1)
            break
          }
        }
        if (options) {
          if (options.onSuccess) {
            options.onSuccess(response, removedItem)
          }
        }
      }, (err) => {
        if (options) {
          if (options.onError) {
            options.onError(err)
          }
        }
      })
  },
  unDoRemoveItem (item, options) {
    // console.log('item should not be remove: ', item)
    axios.post(uris.URL_UNDO_REMOVE_ITEM, {
      itemID: item.itemID
    })
      .then((response) => {
        store.push(item)
        store = this.orderFolderBy(store, ['isFolder', 'itemName'], ['desc', 'asc'])
        if (options) {
          if (options.onSuccess) {
            options.onSuccess(response)
          }
        }
      }, (err) => {
        if (options) {
          if (options.onError) {
            options.onError(err)
          }
        }
      })
  },
  addItem (options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    axios.post(uris.URL_ADD_ITEM, {
      ...options.data
    })
      .then((response) => {
        // console.log('Agregado un elemento', response.data)
        store.push({...response.data.item})
        store = this.orderFolderBy(store, ['isFolder', 'itemName'], ['desc', 'asc'])
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('El elemento no pudo agregarse', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  updatePermissions (options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    axios.post(uris.URL_UPDATE_SUBSCRIPTIONS, {
      userID: options.userID,
      permissions: options.permissions
    })
      .then((response) => {
        // console.log('Actualizado', response)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('No pudo registrarse la visita', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  addItems (items) {
    store = store.concat(items)
  },
  searchItems (queriesArray) {
    /*
    function checkCoincidences (str, coincidences) {
      for (let i = 0; i < coincidences.length; i++) {
        if (str.indexOf(coincidences[i]) > -1) {
          return true
        }
      }
      return false
    }
    */
    function strictCheckCoincidences (str, coincidences) {
      for (let i = 0; i < coincidences.length; i++) {
        if (str.indexOf(coincidences[i]) === -1) {
          return false
        }
      }
      return true
    }

    queriesArray = queriesArray.map(i => i.toLowerCase())
    return orderBy(filter(store, (item) => {
      const labels = item.labels.trim().toLowerCase()
      const name = item.itemName.trim().toLowerCase()

      const criteria = labels === '' ? name : labels
      // return checkCoincidences(criteria, queriesArray)
      return strictCheckCoincidences(criteria, queriesArray)
    }), ['labels', 'itemName'], ['asc', 'asc'])
  },
  storeLength () {
    return store.length
  },
  getCheckedItems (children) {
    let q = []
    const max = children.length
    for (let i = 0; i < max; i++) {
      if (children[i].checked) {
        q.push(children[i].itemID)
      }
      if (children[i].children.length > 0) {
        q = q.concat(this.getCheckedItems(children[i].children))
      }
    }
    return q
  },
  updateMultipleItemsInheritee (options) {
    /*
    options: {
      data: {
        itemsID: [],
        inherited: 0,
        structureItemInheritance: false
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    axios.post(uris.URL_UPDATE_MULTIPLE_ITEMS_INHERITEE, {
      itemsID: options.data.itemsID,
      inherited: options.data.inherited,
      structureItemInheritance: options.data.structureItemInheritance
    })
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (error) => {
        console.warn('No se pudo actualizar ', error)
        if (options.onError) {
          options.onError(error)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/storage/reportsStorage.js